// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"530":"page","820":"serviceList","945":"dashboard"}[chunkId] || chunkId) + "." + {"91":"04540be2","530":"835c1866","820":"f9ebb706","945":"ef2809f7"}[chunkId] + ".js";
};